var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24.75C26.4853 24.75 28.5 22.7353 28.5 20.25C28.5 17.7647 26.4853 15.75 24 15.75C21.5147 15.75 19.5 17.7647 19.5 20.25C19.5 22.7353 21.5147 24.75 24 24.75Z",
    stroke: "#1B2559",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 30L24 33.75L28.5 30",
    stroke: "#1B2559",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 33.75C17.25 30 20.25 27 24 27C27.75 27 30.75 30 30.75 33.75",
    stroke: "#1B2559",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoles);
export default __webpack_public_path__ + "static/media/Roles.3eb82487861616097827f403e1d50dc9.svg";
export { ForwardRef as ReactComponent };